import * as React from 'react';
import {Link} from 'react-router-dom';

import {LeadTwoLine} from 'shells/lead/lead-two-line';

import type {LeadSearchResult as LeadSearchResultFragment} from 'nutshell-graphql-types';

import styles from './search-results.module.css';

type Props = LeadSearchResultFragment & {
    isActive?: boolean;
    closeSidebar: () => void;
};

export class SearchResultLead extends React.PureComponent<Props> {
    render() {
        const primaryAccount = this.props.accounts.primaryEdge
            ? this.props.accounts.primaryEdge.node
            : undefined;

        const primaryContact = this.props.contacts.primaryEdge
            ? this.props.contacts.primaryEdge.node
            : undefined;

        return (
            // @ts-expect-error
            <Link
                to={this.props.htmlUrlPath}
                onClick={this.props.closeSidebar}
                className={
                    this.props.isActive
                        ? styles['search-result--fake-focus']
                        : styles['search-result']
                }
            >
                <LeadTwoLine
                    isLinkable={false}
                    disableRouting={true}
                    leadName={this.props.name}
                    leadNumber={this.props.number}
                    leadStatus={this.props.status}
                    htmlUrl={this.props.htmlUrlPath}
                    priority={this.props.priority}
                    formattedValue={
                        this.props.value && this.props.value.formattedValue
                            ? {
                                  formatted: this.props.value.formattedValue.formatted,
                                  prefix: this.props.value.formattedValue.prefix,
                                  suffix: this.props.value.formattedValue.suffix,
                                  value: this.props.value.formattedValue.value,
                              }
                            : undefined
                    }
                    avatarUrl={this.props.avatarUrl}
                    relatedPerson={primaryContact}
                    relatedCompany={primaryAccount}
                />
            </Link>
        );
    }
}
